import { TextField } from "@mui/material";
import DireccionConMapa from './DireccionConMapa';
import React, { useState } from "react";

const AddAdress = () => {
    // Coordenadas iniciales del mapa
    const [mapPosition, setMapPosition] = useState([19.4326, -99.1332]); // Separado del formulario
    const [formData, setFormData] = useState({
        Address: "",
        AddressMaps: "",
        Street: "",
        Colony: "",
        PostalCode: "",
        City: "",
    });

    // Actualiza el formulario y, opcionalmente, el mapa al geocodificar
    const handleDireccionChange = (direccion) => {
        setFormData((prevData) => ({
            ...prevData,
            Address: direccion,
        }));

        console.log("Dirección a geocodificar:", direccion);

        const fetchCoordinates = async () => {
            const res = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${direccion}&addressdetails=1`
            );
            const data = await res.json();
            if (data && data[0]) {
                console.log("Datos de geocodificación:", data[0]);
                const { lat, lon } = data[0];
                setMapPosition([parseFloat(lat), parseFloat(lon)]); // Actualiza el mapa con la dirección del formulario
            } else {
                console.log("No se encontró la dirección.");
            }
        };

        fetchCoordinates();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const onBlur = () => {
        const address = `${formData.Street}, ${formData.Colony}, ${formData.PostalCode}, ${formData.City} MX`;
        console.log("Dirección generada desde el formulario:", address);
        handleDireccionChange(address);
    };

    // Recibe las nuevas coordenadas del mapa cuando el usuario hace clic
    const handleMoveMap = (newPosition) => {
        setMapPosition(newPosition); // Actualiza solo la posición del mapa
        console.log("Nueva posición del mapa:", newPosition);
    };

    return (
        <div className="space-y-4">
            <TextField
                label="Nombre Consultorio Ej. (Citident)"
                name="logoname"
                fullWidth
                onChange={handleChange}
                value={formData.logoname || ""}
            />
            <TextField
                label="Código Postal"
                name="PostalCode"
                fullWidth
                onBlur={onBlur}
                onChange={handleChange}
                value={formData.PostalCode}
            />
            <TextField
                label="Ciudad"
                name="City"
                fullWidth
                onBlur={onBlur}
                onChange={handleChange}
                value={formData.City}
            />
            <TextField
                label="Colonia"
                name="Colony"
                fullWidth
                onBlur={onBlur}
                onChange={handleChange}
                value={formData.Colony}
            />
            <TextField
                label="Calle"
                name="Street"
                fullWidth
                onBlur={onBlur}
                onChange={handleChange}
                value={formData.Street}
            />
            <DireccionConMapa addressposition={mapPosition} handleMoveMap={handleMoveMap} />
        </div>
    );
};

export default AddAdress;